import React from 'react'
import { Link } from '@paypalcorp/pp-react'
// import data from "../../content/footer.en-XC.yaml"
import footerStyles from './Footer.module.css'

interface FooterProps {
  inverseHeaderScheme: boolean
}

const Footer: React.FC<FooterProps> = ({ inverseHeaderScheme }) => {
  const footerLinks = [
    { text: 'Reference', link: '/reference', target: '_self' },
    { text: 'PayPal.com', link: 'https://www.paypal.com/', target: '_blank' },
    {
      text: 'Privacy',
      link: 'https://www.paypal.com/us/webapps/mpp/ua/privacy-full',
      target: '_blank',
    },
    { text: 'Support', link: '/docs/support', target: '_self' },
    {
      text: 'Legal',
      link: 'https://www.paypal.com/us/webapps/mpp/ua/legalhub-full',
      target: '_blank',
    },
    {
      text: 'Contact',
      link: 'https://www.paypal.com/us/smarthelp/contact-us',
      target: '_blank',
    },
  ]
  const links = footerLinks.map((l, i) => (
    <Link
      key={`${l.text}-${i}`}
      secondary
      href={l.link}
      className={`${footerStyles.footerLinks} ${footerStyles.footerText}`}
      target={l.target}
    >
      {l.text}
    </Link>
  ))

  return (
    <div
      className={
        inverseHeaderScheme
          ? footerStyles.footerContainerWhite
          : footerStyles.footerContainer
      }
    >
      <div className={footerStyles.footerWrapper}>
        <div className={footerStyles.linkBtnContainer}>{links}</div>
      </div>
    </div>
  )
}

export default Footer
